'use strict';
module.exports = str => encodeURIComponent(str).replace(/[!'()*]/g, x => `%${x.charCodeAt(0).toString(16).toUpperCase()}`);



// WEBPACK FOOTER //
// ./node_modules/calendar-link/node_modules/strict-uri-encode/index.js